// libraries
import { paymentSelectors } from '@makemydeal/dr-offer-redux';

// types
import type { PaymentFeesTypesState } from '../types/types';
import type { StateTree } from '@makemydeal/dr-dash-types';

export const getPaymentFeesTypesState = (state: StateTree): PaymentFeesTypesState => {
    return state.payment || {};
};

export const getPaymentFeesTypes = (state: StateTree) => {
    return getPaymentFeesTypesState(state).feesByCategory || [];
};

export const {
    isCalculatingPayment,
    isAwaitingFreshPaymentResponse,
    isFetchingPayment,
    getPaymentLocationId,
    /** If this returns true, it means a payment call failed to return calculations  */
    getIsError,
    getErrorCategory,
    getIsShopperUpdateFailed,
    getActionForPayment,
    getIsLenderChanged,
    getPaymentsCalculated,
    getFirstPaymentDateBySelectedTerm
} = paymentSelectors;
